import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { OpportunitiesListComponent } from '@pages/opportunities/opportunities-list/opportunities-list.component';
import { FilterStateService } from '@services/filter-state.service';
import { OpportunitiesFiltersComponent } from '@shared/opportunities-filters/opportunities-filters.component';
import {
    IAdditionalFiltersOpportunities,
    IMainFiltersOpportunities,
    OPPORTUNITIES_BUILDING_FILTER_KEY
} from '@shared/opportunities-filters/opportunity-filters.config';

@Component({
    selector: 'app-buildings-single-opportunities',
    templateUrl: './buildings-single-opportunities.component.html',
    styleUrls: ['./buildings-single-opportunities.component.scss'],
    imports: [OpportunitiesFiltersComponent, OpportunitiesListComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [
        {
            provide: FilterStateService,
            useClass: FilterStateService<IMainFiltersOpportunities, IAdditionalFiltersOpportunities>
        }
    ]
})
export class BuildingsSingleOpportunitiesComponent {
    readonly buildingId = input.required<number>();

    readonly filtersKey = OPPORTUNITIES_BUILDING_FILTER_KEY;

    private readonly router = inject(Router);

    async onNewOpportunityClicked(): Promise<void> {
        await this.router.navigate(['/opportunities-create'], {
            queryParams: {
                buildingId: this.buildingId()
            }
        });
    }
}
